import { buildPagePath, buildPostPath } from '~/composables/usePermalink'

const normalizePath = (value: string) => {
  const text = String(value || '').trim()
  if (!text) {
    return '/'
  }
  if (text === '/') {
    return '/'
  }
  return text.replace(/\/+$/, '')
}

const readLegacySlug = (path: string, prefix: string) => {
  if (!path.startsWith(prefix)) {
    return ''
  }
  const raw = path.slice(prefix.length).split('/').filter(Boolean)[0] || ''
  try {
    return decodeURIComponent(raw).trim()
  } catch {
    return raw.trim()
  }
}

export default defineNuxtRouteMiddleware(async to => {
  const path = String(to.path || '')
  const isLegacyPost = path.startsWith('/post/')
  const isLegacyPage = path.startsWith('/page/')
  if (!isLegacyPost && !isLegacyPage) {
    return
  }

  const slug = isLegacyPost ? readLegacySlug(path, '/post/') : readLegacySlug(path, '/page/')
  if (!slug) {
    return
  }

  const siteData = await useSiteData()
  const fields = siteData?.setting?.customFields
  const targetPath = isLegacyPost ? buildPostPath(fields, { slug }) : buildPagePath(fields, { slug })

  if (!targetPath || normalizePath(targetPath) === normalizePath(path)) {
    return
  }

  return navigateTo(
    {
      path: targetPath,
      query: to.query,
      hash: to.hash
    },
    {
      redirectCode: 301,
      replace: true
    }
  )
})
